export const ensureTrailingSlash = (url: string): string => {
  return url.endsWith('/') ? url : `${url}/`;
};

export const ensureNoTrailingSlash = (url: string): string => {
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

const buildUrl = (url: string, path: string): string => {
  return ensureNoTrailingSlash(`${ensureTrailingSlash(url)}${path}`);
};

export default buildUrl;
